import { requst } from '../config'

export const getTextDataApi = projectId => {
    const url = `/yf/map/geojson/geojson?fileName=Revised_Design0321.S&projectId=1628570729250291713`
    return requst.get(url)
}

export const getPreplotLayers = projectId => {
    const url = `/map/daily/getPreplotLayers/${projectId}`
    return requst.get(url)
}

export const getSourceLayers = projectId => {
    const url = `/map/daily/getSourceLayers/${projectId}`
    return requst.get(url)
}

export const getNodeDeployedLayers = projectId => {
    const url = `/map/daily/getNodeDeployedLayers/${projectId}`
    return requst.get(url)
}

export const getNodeRecoverLayers = projectId => {
    const url = `/map/daily/getNodeRecoverLayers/${projectId}`
    return requst.get(url)
}

export const getJsonData = (url, obj) => {
    return requst.get(url, {
        responseType: 'blob',
        headers: { 'Content-Type': 'application/json; application/octet-stream' },
        ...obj
    })
}

export const postQueryChangeResource = params => {
    const url = `/map/daily/queryChangeResource`
    return requst.post(url, params)
}

export const getPositioningList = () => {
    const url = `/map/screenshot/list`
    return requst.get(url)
}

export const putPositioning = params => {
    const url = `/map/screenshot`
    return requst.put(url, params)
}

export const getPointTotal = projectId => {
    const url = `/setting/workload/obn/projectId/${projectId}`
    return requst.get(url)
}

export const getLayerTreeList = projectld => {
    const url = `/map/daily/getLayerTree/${projectld}`
    return requst.get(url)
}

export const getNowDeployment = (projectld, rangePicker) => {
    const url = `/map/daily/getNowReceiver?projectId=${projectld}&type=f&date=${rangePicker[1]}`
    return requst.get(url)
}

export const getNowRetrieval = (projectld, rangePicker) => {
    const url = `/map/daily/getNowReceiver?projectId=${projectld}&type=s&date=${rangePicker[1]}`
    return requst.get(url)
}

export const getNowSource = (projectld, rangePicker) => {
    const url = `/map/daily/getNowSource?projectId=${projectld}&type=f&date=${rangePicker[1]}`
    return requst.get(url)
}

export const getNowStreamer = (projectld, rangePicker) => {
    const url = `/map/daily/getNowStreamer?projectId=${projectld}&type=f&date=${rangePicker[1]}`
    return requst.get(url)
}

// 进度
export const postProgessSize = params => {
    const url = `map/file/getMapFileLoadInfo`
    return requst.post(url, params)
}
